import React, { useEffect, useMemo, useState } from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { DialogActions } from '@material-ui/core';

import './style.scss'
import Button from '../../../../../../components/Buttons/Button';
import { useDispatch, useSelector } from 'react-redux';
import SearchBox from '../../../../../../components/SearchBox/SearchBox';
import UpdateDetail from './UpdateDetail';
import { doGetUpdateDetails } from '../../../../../../redux/thunks/readers';
import { useParams } from 'react-router-dom';
import SDialog from '../../../../../../components/SDialog/SDialog';
import FlexColumn from '../../../../../../components/FlexBox/FlexColumn';
import { doReadDeviceUpdateList } from '../../../../../../redux/actionCreators/readers';

const FirmwareUpdateDetails = ({ open, onClose, sites, readers = [] }) => {

    const dispatch = useDispatch();

    const { customerId } = useParams();

    const { updateDevices } = useSelector((state) => ({
        updateDevices: state.readers.updateDevices,
    }));

    const [search, setSearch] = useState('');

    useEffect(() => {
        if (open) {
            dispatch(doGetUpdateDetails({ sites: sites }, customerId))
        }
    }, [open, customerId, sites, dispatch])

    const filteredUpdateDeviceList = useMemo(() => {
        const readersMap = Object.fromEntries(readers?.map(item => [item.id, item]));
        let tempUpdateReaders = JSON.parse(JSON.stringify(updateDevices));
        tempUpdateReaders = tempUpdateReaders?.map(r => ({ ...r, accessPoint: readersMap[r.serialNumber]?.accessPoint || '' }));
        return tempUpdateReaders?.filter(ap => ap?.accessPoint?.includes(search)) || []
    }, [readers, updateDevices, search])


    const popupToggle = () => {
        dispatch(doReadDeviceUpdateList({ updateDevices: [] }));
        onClose();
    };

    const hSearch = (e) => {
        const { value } = e?.target;
        setSearch(value?.trimStart());
    }

    return (
        <SDialog
            title='Firmware Update'
            open={open}
            onClose={popupToggle}
            primaryButtonConfig={{
                text: 'Close',
                color: 'brand',
                onClick: popupToggle
            }}
            isFormDialog={true}
        >
            <FlexColumn>
                <SearchBox onChange={hSearch} value={search} />
                <div className='ap-container' style={{ padding: '0.5rem 1rem', marginTop: '1rem', width: '100%' }}>
                    <Typography variant='h7' className='ap-title'>Doors</Typography>
                </div>
                <div className='scroll-container' style={{ width: '100%' }}>
                    {filteredUpdateDeviceList?.map(d => (
                        <UpdateDetail readerDetails={d} sites={sites} />
                    ))}
                </div>
            </FlexColumn>
        </SDialog>
    );
};

export default FirmwareUpdateDetails;
